import ForgottenPassword from './forgottenPassword'

export default ForgottenPassword
